export default "__VITE_ASSET__C$0B3CeW__"